module.exports = __webpack_public_path__ + "img/conny-stage4.3237c3d4.png";